export function tryJSONParse(v: any) {
  try {
    return JSON.parse(v as string);
  } catch (e) {
    return v as string;
  }
}
